export const splitTextIntoParagraphs = (text) => {
  if (!text) return [];
  const paragraphs = text.split(/\n\n/)
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
  return paragraphs.length > 0 ? paragraphs : [text.trim()];
};

export const getConsecutiveAssistantMessages = (chatList) => {
  const messages = [];
  for (let i = chatList.length - 1; i >= 0; i--) {
    if (chatList[i].role === "ASSISTANT") {
      messages.unshift(chatList[i]);
    } else {
      break;
    }
  }
  return messages;
};

export const initialAudioState = {
  isPlaying: false,
  isEnded: false,
  isReady: false,
  isConverting: false,
  isConversionComplete: false,
  isWaitingForUserVoice: false,
  isWaitingForVoiceConversion: false,
  isWaitingForAssistantResponse: false,
  isWaitingForAssistantVoice: false,
  showDeviceSelector: false,
  showSpeedSelector: false,
  currentUrl: null,
  playIndex: 0,
  activePlayIndex: -1,
  convertIndex: 0,
  mouthState: "CLOSED",
  playbackRate: 1.25,
  isPaused: false,
};

export const audioReducer = (state, action) => {
  switch (action.type) {
    case "START_PLAYBACK":
      return {
        ...state,
        isPlaying: true,
        isPaused: false,
        isReady: false,
        isEnded: false,
        activePlayIndex: state.playIndex - 1,
        isWaitingForUserVoice: false,
        isWaitingForVoiceConversion: false,
        isWaitingForAssistantResponse: false,
        isWaitingForAssistantVoice: false,
      };
    case "PAUSE_PLAYBACK":
      return {
        ...state,
        isPlaying: false,
        isPaused: true,
      };
    case "RESUME_PLAYBACK":
      return {
        ...state,
        isPlaying: true,
        isPaused: false,
      };
    case "END_PLAYBACK":
      return {
        ...state,
        isPlaying: false,
        isPaused: false,
        isEnded: action.payload?.reset ? false : true,
        activePlayIndex: action.payload?.reset ? -1 : state.activePlayIndex,
        mouthState: "CLOSED",
        isWaitingForUserVoice: false,
        isWaitingForVoiceConversion: false,
        isWaitingForAssistantResponse: false,
        isWaitingForAssistantVoice: false,
      };
    case "SET_READY":
      return {
        ...state,
        isReady: true,
        playIndex: state.playIndex + 1,
        currentUrl: action.payload,
        isEnded: false,
        isPaused: false,
      };
    case "START_CONVERSION":
      return {
        ...state,
        isConverting: true,
      };
    case "END_CONVERSION":
      const nextIndex = state.convertIndex + 1;
      const isComplete = nextIndex >= action.payload.audioItemListLength;
      return {
        ...state,
        isConverting: false,
        convertIndex: nextIndex,
        isConversionComplete: isComplete,
      };
    case "RESET":
      return { ...initialAudioState, playbackRate: state.playbackRate };
    case "RESET_INDICES":
      return {
        ...state,
        playIndex: 0,
        activePlayIndex: -1,
        convertIndex: 0,
      };
    case "SET_MOUTH_STATE":
      return { ...state, mouthState: action.payload };
    case "SET_WAITING_FOR_USER_VOICE":
      return {
        ...state,
        isConversionComplete: false,
        isPlaying: false,
        isPaused: false,
        isEnded: false,
        isReady: false,
        isWaitingForUserVoice: true,
        isWaitingForVoiceConversion: false,
        isWaitingForAssistantResponse: false,
        isWaitingForAssistantVoice: false,
      };
    case "SET_WAITING_FOR_VOICE_CONVERSION":
      return {
        ...state,
        isPlaying: false,
        isPaused: false,
        isEnded: false,
        isReady: false,
        isWaitingForUserVoice: false,
        isWaitingForVoiceConversion: true,
        isWaitingForAssistantResponse: false,
        isWaitingForAssistantVoice: false,
      };
    case "SET_WAITING_FOR_ASSISTANT_RESPONSE":
      return {
        ...state,
        isPlaying: false,
        isPaused: false,
        isEnded: false,
        isReady: false,
        isWaitingForUserVoice: false,
        isWaitingForVoiceConversion: false,
        isWaitingForAssistantResponse: true,
        isWaitingForAssistantVoice: false,
      };
    case "SET_WAITING_FOR_ASSISTANT_VOICE":
      return {
        ...state,
        isPlaying: false,
        isPaused: false,
        isEnded: false,
        isReady: false,
        isWaitingForUserVoice: false,
        isWaitingForVoiceConversion: false,
        isWaitingForAssistantResponse: false,
        isWaitingForAssistantVoice: true,
      };
    case "TOGGLE_DEVICE_SELECTOR":
      return {
        ...state,
        showDeviceSelector: !state.showDeviceSelector,
        showSpeedSelector: false,
      };
    case "TOGGLE_SPEED_SELECTOR":
      return {
        ...state,
        showSpeedSelector: !state.showSpeedSelector,
        showDeviceSelector: false,
      };
    case "SET_PLAYBACK_RATE":
      return {
        ...state,
        playbackRate: action.payload,
        showSpeedSelector: false,
      };
    default:
      return state;
  }
};
